const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/system/settings.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
// Admin Global Settings Layout
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/system/settings")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Global Settings",
      description: "Page title"
    })
  }
});